import React, { useState } from 'react';
import { Mail, Loader2, CheckCircle2 } from 'lucide-react';
import { api } from '../lib/api';

const SaveFinderResult = ({ payload }) => {
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [hp, setHp] = useState('');
    const [busy, setBusy] = useState(false);
    const [done, setDone] = useState(false);
    const [error, setError] = useState('');

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true); setError('');
        try {
            await api.post('/finder/save', { ...payload, email, name, website: hp });
            if (window.trackConversion) window.trackConversion('finder_result_saved', { tier: payload.tier });
            setDone(true);
        } catch (err) {
            const d = err.response?.data?.detail;
            setError(typeof d === 'string' ? d : 'Please enter a valid email address.');
        }
        setBusy(false);
    };

    if (done) {
        return (
            <div className="border border-emerald-200 bg-emerald-50 p-5 flex gap-3 items-center max-w-3xl" data-testid="finder-save-success">
                <CheckCircle2 className="h-6 w-6 text-emerald-600 flex-shrink-0" />
                <p className="text-sm text-neutral-800">Sent! Check <b>{email}</b> for your result — it includes a link to come back to it anytime.</p>
            </div>
        );
    }

    return (
        <form onSubmit={submit} className="border border-neutral-200 bg-white p-5 max-w-3xl" data-testid="finder-save-form">
            <div className="flex items-center gap-2 font-display font-bold uppercase text-lg text-neutral-900"><Mail className="h-5 w-5 text-brand-primary" /> Email me this result</div>
            <p className="mt-1 text-sm text-neutral-600">Save your recommendation and come back when you&apos;re ready to buy.</p>
            <input type="text" tabIndex={-1} autoComplete="off" value={hp} onChange={(e) => setHp(e.target.value)} className="hidden" aria-hidden="true" />
            <div className="mt-4 grid grid-cols-1 sm:grid-cols-[1fr_1fr_auto] gap-3">
                <input value={name} onChange={(e) => setName(e.target.value)} placeholder="First name (optional)" className="border border-neutral-300 px-3 py-3 text-neutral-900 focus:outline-none focus:border-brand-primary" data-testid="finder-save-name" />
                <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" className="border border-neutral-300 px-3 py-3 text-neutral-900 focus:outline-none focus:border-brand-primary" data-testid="finder-save-email" />
                <button type="submit" disabled={busy} className="inline-flex items-center justify-center gap-2 bg-neutral-900 hover:bg-brand-primary text-on-dark font-bold px-6 py-3 label-caps transition-colors" data-testid="finder-save-submit">
                    {busy && <Loader2 className="h-4 w-4 animate-spin" />} Send
                </button>
            </div>
            {error && <p className="mt-2 text-sm text-red-600" data-testid="finder-save-error">{error}</p>}
        </form>
    );
};

export default SaveFinderResult;
